// extracted by mini-css-extract-plugin
export default {"timer-duration-control":"lsf-timer-duration-control","waiting":"lsf-waiting"};